import config from '../config';

import Sistema from '../constants/Sistema';
import ApiV2 from './ApiV2';

class IndiqueGanheService {
  static getIndicacoes(id_usuario, id_entidade) {
    return ApiV2.get('/indique-ganhe/get-indicacoes', {
      params: { id_usuario, id_entidade },
    });
  }

  static getRegulamento(id_matricula) {
    return ApiV2.get('/indique-ganhe/get-regulamento', {
      params: { id_matricula, id_entidade: config.entidadeTextosSistema },
    });
  }

  static getComoFunciona(id_matricula) {
    return ApiV2.get('/indique-ganhe/get-como-funciona', {
      params: { id_matricula, id_entidade: config.entidadeTextosSistema },
    });
  }

  static getConfirmacaoTermos(id_usuario) {
    return ApiV2.get('/indique-ganhe/get-confirmacao-termos', {
      params: { id_usuario },
    });
  }

  static getParceiros(id_matricula) {
    return ApiV2.get('/indique-ganhe/get-parceiros', {
      params: { id_matricula },
    });
  }

  static criarAfiliado(id_matricula, linha_de_negocio) {
    return ApiV2.post('/indique-ganhe/criar-afiliado', {
      id_matricula,
      id_sistemaindiqueganhe: Sistema.PORTAL_EGRESSO,
      linha_de_negocio,
    });
  }

  static salvarIndicado(codcontratoafiliacao, id_matricula, nome, telefone, ddd, email, linha_de_negocio, id_afiliadoindicacaoorigem) {
    return ApiV2.post('/indique-ganhe/salvar-indicado', {
      codcontratoafiliacao,
      id_matricula,
      nome,
      telefone,
      ddd,
      email,
      linha_de_negocio,
      id_afiliadoindicacaoorigem,
    });
  }

  static resgatarCupons(id_usuario, id_situacao, nu_valor, id_afiliadoindicacaoparceiro = null) {
    return ApiV2.get('/indique-ganhe/resgatar-cupons', {
      params: {
        id_usuario,
        id_situacao,
        nu_valor,
        id_afiliadoindicacaoparceiro,
      },
    });
  }

  static getDadosPessoais(id_usuario, id_entidade) {
    return ApiV2.get('/pessoa/dados-pessoa', {
      params: {
        id_usuario,
        id_entidade,
      },
    });
  }

  static getBlInadimplente(id_entidade, st_cpf) {
    return ApiV2.get('/indique-ganhe/get-bl-inadimplente', {
      params: { id_entidade, st_cpf },
    });
  }
}

export default IndiqueGanheService;
